import '../styles/Footer.css';

export default function Footer({ onLogout }) {

    return (
        <div className="main-screen-footer">
            <div className="footer-content">
                <span className="footer-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a4 4 0 0 0-3-3.87M9 20H4v-2a4 4 0 0 1 3-3.87M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" /></svg>
                </span>
                מערכת ניהול עמותה | כל הזכויות שמורות 2025
            </div>
            {onLogout && (
                <button className="footer-logout-button" onClick={onLogout} title="התנתקות">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16,17 21,12 16,7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    <span>יציאה</span>
                </button>
            )}
        </div>
    );
}